<mat-accordion class="management-accordion">
    <mat-expansion-panel [expanded]="displayMode === DisplayMode.List" [disabled]="true" [ngClass]="{ expanded: displayMode === DisplayMode.Form }" hideToggle class="panel-list">
        <mat-expansion-panel-header
            [ngClass]="{ 'events-inactive': !context?.formContext.formVisible, 'events-active': context?.formContext.formVisible }"
            collapsedHeight="48px"
            expandedHeight="48px"
            class="detail-header">
            <app-list-header
                [createRight]="displayAddbuttom"
                titleText="Mises en page de la vue"
                createIconText="Ajouter une mise en page"
                importDatasourceName="listLayoutsBoxes"
                (created)="onListLayoutCreated()"
                (exported)="onListLayoutExported()"
                (imported)="onListLayoutImported()"
                (helped)="onListLayoutHelped()"></app-list-header>
        </mat-expansion-panel-header>

        <app-list-layouts-boxes-list
            #itemsList
            (itemSelected)="onListLayoutSelected($event)"
            (itemDisplayed)="onListLayoutDisplayed($event)"
            (itemEdited)="onListLayoutEdited($event)"
            (itemDeleted)="onListLayoutDeleted($event)"
            (itemDuplicated)="onListLayoutDuplicated($event)"></app-list-layouts-boxes-list>
    </mat-expansion-panel>
    @if (displayMode === DisplayMode.Form) {
        <mat-expansion-panel [disabled]="!context?.formContext.formVisible" [expanded]="displayMode === DisplayMode.Form" [disabled]="true" hideToggle class="panel-form">
            <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px" class="detail-header">
                <app-detail-header
                    [editRight]="displayEditbuttom"
                    [formMode]="context?.formMode"
                    [displayName]="context?.formContext.item.getDisplayName()"
                    [id]="context?.formContext.item.id"
                    (edited)="onListLayoutEdited(context?.formContext.item)"
                    (displayed)="onListLayoutDisplayed(context?.formContext.item)"
                    (helped)="onListLayoutHelped()"
                    (backToList)="onBackToList()"></app-detail-header>
            </mat-expansion-panel-header>
            <app-list-layout-boxes-detail
                [context]="context"
                (listLayoutUpdated)="onListLayoutUpdated($event)"
                (accessibilitiesUpdated)="onAccessibilitiesUpdated($event)"
                (canceled)="onBackToList()"></app-list-layout-boxes-detail>
        </mat-expansion-panel>
    }
</mat-accordion>
